import { render, staticRenderFns } from "./around-me.vue?vue&type=template&id=1f053d74&scoped=true"
import script from "./around-me.vue?vue&type=script&lang=ts"
export * from "./around-me.vue?vue&type=script&lang=ts"
import style0 from "./around-me.vue?vue&type=style&index=0&id=1f053d74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f053d74",
  null
  
)

export default component.exports